export default "__VITE_ASSET__9966e791__"